module.exports = __webpack_public_path__ + "static/media/reverse_age_mri.ae46ed78.webp";